import { configureOpenApiClients } from '../../api/configure';
import { assistanceGetAssistanceOptions, assistanceSendAssistance } from '../../api/v2';

type AssistanceStationBooking = {
  assistanceAtStation: boolean;
  id: string;
  information: string;
};

type AssistanceBooking = {
  assistanceAid: string;
  arrivalStation: AssistanceStationBooking;
  departureStation: AssistanceStationBooking;
  assistanceNeeds: string;
  confirmationMethod: string;
  descriptionOfNeed: string;
  luggage: number;
  phoneNumber: string;
  travelAlone: boolean;
  authorization?: string;
};

type BookingData = {
  orderId: string;
  orderLineId: string;
  booking: AssistanceBooking;
};

export const useAssistanceApi = (token: string) => {
  configureOpenApiClients();

  const getAssistanceOptions = async () => await assistanceGetAssistanceOptions();

  const sendAssistance = async (bookingData: BookingData) => {
    const options = {
      headers: { authorization: 'Bearer ' + token },
      query: { orderLineId: bookingData.orderLineId, orderId: bookingData.orderId },
      body: bookingData.booking,
    };
    return await assistanceSendAssistance(options);
  };

  return {
    getAssistanceOptions,
    sendAssistance,
  };
};
